import { useCompany } from '../../context/CompanyContext';

interface NavbarProps {
  currentPage: string;
  onNavigate: (page: string) => void;
  onOpenMobileMenu: () => void;
  isCollapsed: boolean;
}

export function Navbar({ currentPage, onNavigate, onOpenMobileMenu }: NavbarProps) {
  const { companies, selectedCompanyId, setSelectedCompanyId } = useCompany();

  const getPageTitle = (page: string): { title: string; category: string } => {
    const titles: Record<string, { title: string; category: string }> = {
      dashboard: { title: 'Executive Dashboard', category: 'Workspace' },
      quotations: { title: 'Quotations & Bidding', category: 'Workspace' },
      parties: { title: 'Customer Master Database', category: 'Workspace' },
      companies: { title: 'Operating Companies', category: 'Workspace' },
      products: { title: 'Product Catalog', category: 'Catalog' },
      pricelist: { title: 'Component Price List', category: 'Catalog' },
      lattice: { title: 'Lattice Calculator', category: 'Catalog' },
      reports: { title: 'Reports & Analytics', category: 'Operations' },
      import: { title: 'Bulk Data Import', category: 'Operations' },
      stock: { title: 'Stock Inventory', category: 'Operations' },
      tracker: { title: 'Project Tracker', category: 'System' },
      help: { title: 'User Guide & SOP', category: 'System' },
    };
    return titles[page] || { title: 'Enterprise Portal', category: 'System' };
  };

  const pageInfo = getPageTitle(currentPage);

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200">
      <div className="px-4 lg:px-6 h-14 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <button onClick={onOpenMobileMenu} className="lg:hidden p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg">☰</button>
          <div>
            <div className="flex items-center gap-1.5 text-xs text-gray-400">
              <span>{pageInfo.category}</span>
              <span>/</span>
              <span className="font-medium text-gray-700">{pageInfo.title}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <div className="flex items-center gap-1.5 border border-gray-200 rounded-lg px-2.5 py-1.5">
            <span className="text-xs">🏢</span>
            <select
              value={selectedCompanyId}
              onChange={(e) => {
                const val = e.target.value;
                setSelectedCompanyId(val === 'all' ? 'all' : parseInt(val, 10));
              }}
              className="bg-transparent text-xs font-medium text-gray-700 focus:outline-none cursor-pointer max-w-[180px] truncate"
            >
              <option value="all">All Branches (Consolidated)</option>
              {companies.map(c => (
                <option key={c.id} value={c.id}>{c.code} • {c.name}</option>
              ))}
            </select>
          </div>
          {currentPage !== 'quotations' && (
            <button onClick={() => onNavigate('quotations')} className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors">
              <span>+</span>
              <span className="hidden sm:inline">New Quotation</span>
            </button>
          )}
          <button onClick={() => onNavigate('help')} className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg" title="Help">📖</button>
        </div>
      </div>
    </header>
  );
}
